import React, { useState } from "react";

import { Button } from "app/components/ui/button";

const commonQuestionsData = [
  {
    id: 1,
    question: "Can I keep my phone number?",
    answer:
      "Absolutely! You can bring your current phone number to VLE Mobile. We'll help you transfer it quickly and easily - usually takes just a few hours.",
  },
  {
    id: 2,
    question: "What if my phone is locked to another carrier?",
    answer:
      "You'll need to contact your current carrier to unlock your phone before switching.",
  },
  {
    id: 3,
    question: "Do I need a special phone for triple network access?",
    answer:
      "No, any compatible unlocked phone will automatically access all available networks.",
  },
  {
    id: 4,
    question: "What's included with your VLE Mobile plan?",
    answer:
      "All plans include unlimited talk & text, data with triple network access, and 5G coverage.",
  },
];

export const CommonQuestions = () => {
  const [openQuestion, setOpenQuestion] = useState<number | null>(null);

  const handleQuestionToggle = (questionId: number) => {
    setOpenQuestion(openQuestion === questionId ? null : questionId);
  };

  return (
    <section className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12 pt-9 pb-14 sm:pt-14 sm:pb-[4.5rem] md:py-[5.5rem] lg:pt-[7.5rem] lg:pb-[7.725rem]">
      <div className="w-full max-w-[65.75rem] mx-auto">
        <div className="mb-6 text-center sm:mb-9 md:mb-12 lg:mb-14 2xl:mb-[3.75rem]">
          <h2 className="font-mobile text-[#1D1D1B] text-[clamp(1.5rem,calc(2.5vw+1rem),3.125rem)] font-normal leading-snug md:leading-normal lg:leading-[5.25rem]">
            Frequently Asked Questions
          </h2>
          <p className="text-[#1D1D1B] text-[0.925rem] sm:text-base lg:text-lg font-normal leading-5 sm:leading-6 lg:leading-7">
            Find answers to common questions about our service
          </p>
        </div>
        <ul className="mx-auto space-y-4 w-full sm:space-y-5 lg:space-y-6">
          {commonQuestionsData.map((question, index) => (
            <li
              key={index}
              className={`pt-0 overflow-hidden ${
                index === commonQuestionsData.length - 1
                  ? "border-b-0"
                  : "pb-5 sm:pb-7 lg:pb-9 border-b border-[#E4E7EC]"
              }`}
            >
              <Button
                type="button"
                variant="ghost"
                className="gap-4 justify-between w-full text-left rounded-none transition-colors duration-100 hover:bg-transparent sm:gap-6"
                onClick={() => handleQuestionToggle(question.id)}
                aria-expanded={openQuestion === question.id}
                aria-controls={`faq-content-${question.id}`}
              >
                <h4 className="font-mobile text-[#101828] text-[0.925rem] sm:text-base lg:text-lg font-medium leading-5 sm:leading-6 lg:leading-7 flex-1 min-w-0">
                  <span className="whitespace-normal break-words line-clamp-2">
                    {question.question}
                  </span>
                </h4>
                <div className="shrink-0">
                  <img
                    src={
                      openQuestion === question.id
                        ? "/assets/minus-circle.svg"
                        : "/assets/plus-circle.svg"
                    }
                    alt={openQuestion === question.id ? "Collapse" : "Expand"}
                    className="size-5 sm:size-[1.375rem] lg:size-6 transition-transform duration-100 ease-in-out"
                  />
                </div>
              </Button>
              <div
                id={`faq-content-${question.id}`}
                className={`overflow-y-auto transition-all duration-100 ease-in-out ${
                  openQuestion === question.id
                    ? "max-h-96 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-[#667085] text-sm sm:text-[0.925rem] lg:text-base font-normal leading-5 sm:leading-[1.375rem] lg:leading-6 pt-1 sm:pt-1.5 lg:pt-2">
                  {question.answer}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
